import React from 'react';
import {useRouter} from '../../providers/Router/RouterProvider';

import './styles.css';
import { CHARGER_IMAGE, PRICING_CHART_IMAGE } from '../../assets/images';

export const RatePlanScreen = () => {
  const { navigate } = useRouter();
  const handleConfirm = () => navigate('session');
  const handleCancel = () => navigate('home');
  return (
    <div className='container mx-auto max-w-sm'>
      <div className="RatePlanScreen bg-background text-gray-800 h-screen p-4 flex flex-col gap-1 justify-between">
        <h1 className="text-3xl font-bold text-center mb-6">ON 603</h1>

        <div className="p-4 flex justify-center items-center">
          <div className="w-48 h-48 flex flex-col justify-center items-center">
            <img src={CHARGER_IMAGE} alt="Orange Charger" />
          </div>
        </div>

        <div className="">
          <img src={PRICING_CHART_IMAGE} alt="Pricing" className='w-full h-auto'/>
        </div>

        <div className="mt-auto flex justify-between">
          <button className="border-2 border-primary text-primary px-6 py-3 rounded-full" onClick={handleCancel}>
            Cancel
          </button>
          <button className="bg-primary text-white px-6 py-3 rounded-full" onClick={handleConfirm}>
            Confirm & Charge
          </button>
        </div>
      </div>
    </div>
  );
}